<div class="horizontal-large">
  @if (changeCurrentSalesCycle) {
    <button nz-button [nzType]="isShowAll ? 'primary' : 'default'" nzSize="large" (click)="onShowAllClick()">
      Show All
    </button>
  }
  <ul class="breadcrumb">
    @for (item of selectableSalesCycleList(); track $index) {
      <li>
        <a (click)="onSalesCycleClick(item)" [ngClass]="item.isSelected ? 'is-active' : ''">{{ item.value.title }}</a>
      </li>
    }
  </ul>
</div>
